import { ServiceProvider } from "Service";
import { Page } from "./Page";
import { Util } from "Core/Util";
import CancellationToken from "cancellationtoken";

export class FileDownloadPage extends Page {
    constructor(serviceProvider: ServiceProvider, private fileId: number, private objectId: number, private tableName: string) {
        super(serviceProvider);
    }

    async render(layout: kendo.Layout, cancellationToken: CancellationToken): Promise<void> {
        const downloadFile = await this.serviceProvider.FileDownload.get(this.fileId, this.objectId, this.tableName);
        if (downloadFile.File) {
            Util.saveFileBase64(downloadFile.File, downloadFile.MimeType, downloadFile.FileName);
            if (opener) {
                self.close();
            }
        }
    }
}
